// extracted by mini-css-extract-plugin
export default {"block":"Highlight_block__R7Oj0","text":"Highlight_text__XFHxm","stroke":"Highlight_stroke__y3ul2"};